export const pinnedGroupHeader = "c7MgDc";
export default {pinnedGroupHeader};